import React from 'react';

import Header from '../inc/Header';
import lodge from '../images/berhamporehotel.jpg';
import Hotel from '../images/pinewoodbuilding.jpeg';
import BarHotel from '../images/bar.jpeg';

import Slider2 from "../inc/Slider2";
import Slider3 from "../inc/Slider3";
import Parkinghave from '../images/parking.jpeg';
import Natural from '../images/naturalE.jpg';
// import Enterpinour from '../images/enterpinour.jpg';
// import Shoap from '../images/shoap.jpg';
// import Tour from '../images/tour.jpg';
// import Edu from '../images/edu.jpg';
// import Photographer from '../images/photographer.jpg';
// import AddBook from '../AddBook';

import ScrollToTop from "react-scroll-to-top";


function Services() {
  
    return (
      
<>



<Header/>
<br/>
<br/>
<br/>


<div class="p-0 mb-0 bg-white text-dark">
<div className="album py-0">
        
        <div className="container">

            <div className="row">
            <div className="col-md-7">
              
                  
            
                  <small>  <b>Hotel Pinewood</b></small>
                        
                    
                    </div>

                  
              
                </div>
                </div>
                </div>
   
</div>

<ScrollToTop smooth top="100" color="purple" />
<img src={lodge} className="card-img-top"   alt="lodge" /> 
<br/>
<br/>
<h1 style={{textAlign: "center", color: "gold"}}><b> OUR SERVICES
</b></h1>



<div className="album py-4">
        
        <div className="container">
        
            <div className="row">
            
            <div className="col-md-6 mt-8" >

                       
                           
                                
                                <h4 className="card-text mb-1"> <b>Berhampore Lodge</b></h4>
                                <h6 className="card-text mb-4">BAR, Best Bar in Berhampore</h6>
                                <p className="card-text">Best Hotel in Berhampore, Feel Outstanding</p>
                               
                                <div className="d-flex justify-content-between align-items-center">
                               
                        
                            </div>
                               
                            </div>
                            <br/>
                            <div className="col-md-6 mt-8" >
                        
                        <img src={BarHotel} className="card-img-top"    alt="Bar" />
                           
                                
                                <div className="d-flex justify-content-between align-items-center">
                              
                                
                           
                            </div>
                               
                            </div>
                      
                            
                           
                           
                            
                               
                            </div>
                         
                     
                            </div>
                 
                            </div>
                         <hr/> 

                            <div className="album py-4">
        
        <div className="container">

            <div className="row">
       
            <div className="col-md-6 mt-8" >

                       
            <img src={Hotel} className="card-img-top"   alt="Hotelpinewood" />
                                
                                <div className="d-flex justify-content-between align-items-center">
                               
                        
                            </div>
                               
                            </div>
                            <div className="col-md-5 mt-6" >
                        
                            <h4 className="card-text mb-1"> <b>Hotel Pinewood</b></h4>
                                <h6 className="card-text mb-4">A Unit of Berhampore Lodge</h6>
                                <p className="card-text">Best Hotel in Berhampore, Feel Outstanding</p>
                               
                                <div className="d-flex justify-content-between align-items-center">
                               
                        
                            </div>
                               
                            </div>
                            </div>
                            </div>
                            </div>
                          
                          
                            <hr/>
                            <div className="album py-4">
        
        <div className="container">
        
            <div className="row">
            
            <div className="col-md-6 mt-8" >

                       
                           
                                
                                <h4 className="card-text mb-1"> <b>Berhampore Lodge</b></h4>
                                <h6 className="card-text mb-4">BAR, Best Bar in Berhampore</h6>
                                <p className="card-text">Best Hotel in Berhampore, Feel Outstanding</p>
                               
                                <div className="d-flex justify-content-between align-items-center">
                               
                        
                            </div>
                               
                            </div>
                            <br/>
                            <div className="col-md-6 mt-8" >
                        
                       <Slider2/>
                           
                                
                                <div className="d-flex justify-content-between align-items-center">
                              
                                
                           
                            </div>
                               
                            </div>
                      
                            
                           
                           
                            
                               
                            </div>
                         
                     
                            </div>
                 
                            </div>
                         <hr/> 
                            <div className="album py-4">
        
        <div className="container">

            <div className="row">
       
            <div className="col-md-6 mt-8" >

                       
            <img src={Parkinghave} className="card-img-top"   alt="Parking" />
                                
                                <div className="d-flex justify-content-between align-items-center">
                               
                        
                            </div>
                               
                            </div>
                            <div className="col-md-5 mt-6" >
                        
                                <h6 className="card-text"> <b>Parking Facility</b></h6>
                                <p className="card-text"> Parking facility Available in Berhampore Lodge / Hotel pinewood</p>
                                
                                
                                <div className="d-flex justify-content-between align-items-center">
                         
                            </div>
                               
                            </div>
                            </div>
                            </div>
                            </div>
                        
                            <hr/>
                            <div className="album py-4">
        
        <div className="container">

            <div className="row">
       
            <div className="col-md-6 mt-8" >

                                
                                <h6 className="card-text"> <b>Berhampore Lodge Oppsite Site</b></h6>
                                <p className="card-text">Natural Enveirnment, </p>
                                
                                <div className="d-flex justify-content-between align-items-center">
                               
                        
                            </div>
                               
                            </div>
                            <div className="col-md-6 mt-6" >
                        
                        <img src={Natural} className="card-img-top"   alt="Natural" />
                           
                                
                                <div className="d-flex justify-content-between align-items-center">
                              
                                
                           
                            </div>
                               
                            </div>
                            </div>
                            </div>
                            </div>
                         
                            <hr/>
                            <div className="album py-4">
        
        <div className="container">

            <div className="row">
       
            <div className="col-md-6 mt-8" >

                       
          <Slider3/>
                                
                                <div className="d-flex justify-content-between align-items-center">
                               
                        
                            </div>
                               
                            </div>
                            <div className="col-md-5 mt-6" >
                        
                                <h6 className="card-text"> <b>Our Clean Room</b></h6>
                                <p className="card-text">Berhampore Lodge Room</p>
                                
                                
                                <div className="d-flex justify-content-between align-items-center">
                         
                            </div>
                               
                            </div>
                            </div>
                            </div>
                            </div>
                           
                            <hr/>
                       
                            


</>
        
        );
    }
    
    export default Services